import React, { Fragment } from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';

import AlertMessage from 'components/AlertMessage';
import PaddedDivider from 'components/PaddedDivider';
import UserIdenticon from 'components/UserIdenticon';

const UserFormCard = styled(Card)`
  overflow: visible;
`;

const IdenticonWrapper = styled.div`
  margin-top: 70px;
  display: flex;
  justify-content: center;
  position: relative;
  top: -40px;
  margin-bottom: -40px;
`;

const MutedTypography = styled(Typography)`
  opacity: 0.75;
  font-weight: 500;
  margin-bottom: 30px;
`;

const UserForm = ({
  text,
  isError,
  errorHeading,
  buttons,
  fields,
  align,
  hideCard,
  action,
  form
}) => {
  return (
    <Fragment>
      {isError ? (
        <AlertMessage
          type="error"
          heading={errorHeading}
          message={text}
          gutterBottom
        />
      ) : (
        <Fragment>
          <MutedTypography variant="h5" align={align || 'center'} gutterBottom>
            {text}
          </MutedTypography>
        </Fragment>
      )}

      {fields ? (
        <UserFormCard>
          {action === 'login' && (
            <IdenticonWrapper>
              <UserIdenticon string={form.email} />
            </IdenticonWrapper>
          )}

          <CardContent>
            <Grid container direction="column" spacing={24}>
              <Grid item>{fields}</Grid>
              <Grid item>{buttons}</Grid>
            </Grid>
          </CardContent>
        </UserFormCard>
      ) : (
        <Grid container direction="column" spacing={24}>
          <PaddedDivider />
          <Grid item>{buttons}</Grid>
        </Grid>
      )}
    </Fragment>
  );
};

export default UserForm;
